module.exports = __webpack_public_path__ + "img/baum-logo.e78105c1.png";